/**
 * The host lanes a product-model authoring session writes beside the script (keys = server lane keys in
 * ProductModelSessionProfile, labels = the fenced block labels the assistant emits). Kept apart from
 * productModelDefinition.js, which they are re-exported from, so the session-profile registry - loaded with the first
 * page - does not pull the model runtime and the templates into the main bundle.
 */
export const PARAMS_LANE = 'productModelParams';
export const MEMBERS_LANE = 'productModelMembers';
export const SAMPLES_LANE = 'productModelSamples';
export const HOST_LANES = [
  { key: PARAMS_LANE, label: 'artifact: modelParams', member: 'params' },
  { key: MEMBERS_LANE, label: 'artifact: modelMembers', member: 'members' },
  { key: SAMPLES_LANE, label: 'artifact: modelSamples', member: 'samples' },
];
